import breakpoints from 'static/script/utils/breakpoints';
import defineComponent from 'flight';
import InitData from 'static/script/app/data/init-data';
import { composeAdsenseChannel } from './adsense-utils';

function Adsense() {
    this._loaded = {};

    this.defaultAttrs({
        pageType: 'undefined',
        additionalChannels: []
    });

    this._getAdBlock = function(number) {
        return {
            container: 'adsense-content-block-' + number,
            number: 3,
            lines: 1,
            adLoadedCallback: this._AdLoadedCallback.bind(this)
        };
    };

    this._AdLoadedCallback = function(container, adsLoaded) {
        if (!adsLoaded) {
            return;
        }

        this._loadCount++;

        if (this._loadCount === 1) {
            this.$node.addClass('adsense-active');
        } else if (this._loadCount === 2) {
            this.$node.addClass('adsense-active-two');
        }
    };

    this._getAdBlockLargeScreen = function(number) {
        let adBlock = this._getAdBlock(number);
        adBlock.lines = 2;
        adBlock.longerHeadlines = true;
        return adBlock;
    };

    this._getPageOptions = function() {
        return {
            pubId: 'pub-3205607041006869',
            query: this.$node.data('search-query'),
            adPage: this._getPageIndex(),
            hl: 'sv',
            adsafe: 'medium',
            siteLinks: false,
            channel: composeAdsenseChannel(
                this.attr.pageType,
                this.attr.additionalChannels
            )
        };
    };

    this._getPageIndex = function() {
        if (
            InitData.current() &&
            InitData.current().pageSpecificData &&
            InitData.current().pageSpecificData.paginationActivePageIndex
        ) {
            return InitData.current().pageSpecificData
                .paginationActivePageIndex;
        }
        return 1;
    };

    this._loadUnits = function() {
        this._clearLoaded();
        let pageOptions = this._getPageOptions();

        if (!pageOptions.query) {
            return; // If query is empty, Google Ads will throw js error
        }
        if (breakpoints.isVisible(breakpoints.large)) {
            let adblock1 = this._getAdBlockLargeScreen('1');
            let adblock2 = this._getAdBlockLargeScreen('2');
            pageOptions.siteLinks = true;
            _googCsa('ads', pageOptions, adblock1, adblock2);
        } else {
            let adblock = this._getAdBlock('1');
            _googCsa('ads', pageOptions, adblock);
        }
    };

    this._clearLoaded = function() {
        this._loadCount = 0;
        this.$node.removeClass('adsense-active');
        this.$node.removeClass('adsense-active-two');
    };

    this.after('initialize', function() {
        this._loadUnits();
        this.on(
            document,
            'ui:search-result:after-pagination',
            this._loadUnits.bind(this)
        );
    });
}

export default defineComponent.component(Adsense);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/adsense.js